module.exports = __webpack_public_path__ + "img/数字化运营方案服务商图片.a60e4854.png";